import { render, staticRenderFns } from "./addMotherPackage.vue?vue&type=template&id=1fdadc28&"
import script from "./addMotherPackage.vue?vue&type=script&lang=js&"
export * from "./addMotherPackage.vue?vue&type=script&lang=js&"
import style0 from "./addMotherPackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdadc28')) {
      api.createRecord('1fdadc28', component.options)
    } else {
      api.reload('1fdadc28', component.options)
    }
    module.hot.accept("./addMotherPackage.vue?vue&type=template&id=1fdadc28&", function () {
      api.rerender('1fdadc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addMotherPackage.vue"
export default component.exports